// Ações da página do quadro que componentes profundos (menu do cartão, fila de entrada)
// precisam disparar sem passar por todos os níveis de props (WR-WEB-05, WR-WEB-06).
import { createContext, useContext } from 'react';

export interface KanbanAcoes {
  /** Recarrega o quadro (não depende de o SSE estar conectado). */
  atualizar: () => void;
  /** Mostra um aviso passageiro no quadro. */
  notificar: (tom: 'erro' | 'aviso', texto: string) => void;
}

export const KanbanAcoesContext = createContext<KanbanAcoes>({
  atualizar: () => undefined,
  notificar: () => undefined,
});

export function useKanbanAcoes(): KanbanAcoes {
  return useContext(KanbanAcoesContext);
}
